import React, { useEffect, useMemo, useState } from "react";
import { AiOutlineSearch, AiOutlineEye } from "react-icons/ai";
import { MdOutlineModeEditOutline, MdDeleteOutline } from "react-icons/md";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { RxCross2 } from "react-icons/rx";
import { useGlobalContext } from "../../../../Contexts/GlobalContext";
import axios from "axios";
import { BASE_URL } from "../../../../Utlils";
import DeleteModal from "../../../../components/DeleteModal";
import { IoMdAddCircleOutline } from "react-icons/io";
import { CircularProgress, LinearProgress } from "@mui/material";
import NoData from "../../../../components/NoData";
import {
  applyAIQualifications,
  generateAIQualificationDrafts,
} from "../../surveyActions";
import {
  MultiPunch,
  Numeric,
  SinglePunch,
  Text,
} from "./QualificationForms";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  maxWidth: "95vw",
  maxHeight: "90vh",
  overflow: "visible",
  bgcolor: "#fff",
  boxShadow: "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)",
  borderRadius: "8px",
  outline: "none",
};

const firstModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "452px",
  bgcolor: "#F9F9FF",
  boxShadow: 24,
  borderRadius: 2,
};

const Qualification = ({
  data,
  type,
  id,
  getSingleSurvey,
  qualificationTable,
  getTableQualification,
}) => {
  const [addLogicModal, setAddLogicModal] = useState({
    firstModal: false,
    secondModal: false,
  });
  const [modal, setModal] = useState({ qualification: false, logic: false });
  const { myQuestion, questionLibrary, setSnackbar } = useGlobalContext();
  const allQuestions = useMemo(() => {
    const seen = new Set();
    return [...(myQuestion || []), ...(questionLibrary || [])].filter(
      (question) => {
        if (!question?._id || seen.has(question._id)) return false;
        seen.add(question._id);
        return true;
      }
    );
  }, [myQuestion, questionLibrary]);
  const [tab, setTab] = useState(0);
  const [deleteM, setDeleteM] = useState({ open: false });
  const [previewData, setPreviewData] = useState({});
  const [filters, setFilters] = useState({});
  const [edit, setEdit] = useState({ isEdit: false, data: {} });
  const [aiModal, setAiModal] = useState({
    open: false,
    objective: "",
    stage: "input",
    drafts: [],
    selectedDraftIds: [],
    loading: false,
    applying: false,
    progress: 0,
  });
  const progressIntervalRef = React.useRef(null);

  const handleOpen = (name) => setModal((prev) => ({ ...prev, [name]: true }));
  const handleClose = (name) => {
    setModal((prev) => ({ ...prev, [name]: false }));
    if (name === "qualification") {
      setEdit({});
      setTab(0);
    }
  };
  const openAIModal = () => {
    setAiModal({
      open: true,
      objective: data?.setup?.objective || "",
      stage: "input",
      drafts: [],
      selectedDraftIds: [],
      loading: false,
      applying: false,
      progress: 0,
    });
  };
  const closeAIModal = () => {
    setAiModal((prev) => ({
      ...prev,
      open: false,
      stage: "input",
      drafts: [],
      selectedDraftIds: [],
      loading: false,
      applying: false,
    }));
  };
  useEffect(() => {
    if (aiModal?.loading || aiModal?.applying) {
      progressIntervalRef.current = setInterval(() => {
        setAiModal((prev) => {
          const next = Math.min((prev?.progress || 0) + 3, 95);
          return { ...prev, progress: next };
        });
      }, 400);
    }
    return () => {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = null;
      }
    };
  }, [aiModal?.loading, aiModal?.applying]);

  const clearProgressInterval = () => {
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
      progressIntervalRef.current = null;
    }
  };

  const handleAIGeneration = async () => {
    const objective = aiModal?.objective?.trim();
    if (!objective || objective.length < 10) {
      setSnackbar({
        open: true,
        msg: "Please add an objective with at least 10 characters.",
        severity: "error",
      });
      return;
    }

    setAiModal((prev) => ({ ...prev, loading: true, progress: 0 }));
    try {
      const result = await generateAIQualificationDrafts(id, objective);
      const drafts = result?.drafts || [];
      const selectedDraftIds = drafts
        ?.filter((d) => !d?.alreadyApplied)
        ?.map((d) => d?.draftId);
      setAiModal((prev) => ({
        ...prev,
        loading: false,
        stage: "review",
        objective: result?.objective || prev.objective,
        drafts,
        selectedDraftIds,
        progress: 100,
      }));
      setSnackbar({
        open: true,
        msg: `Generated ${drafts?.length || 0} draft qualification(s). Review and apply.`,
        severity: "success",
      });
    } catch (error) {
      setAiModal((prev) => ({ ...prev, loading: false }));
      setSnackbar({
        open: true,
        msg:
          error?.response?.data?.error ||
          "Unable to generate qualification drafts with AI.",
        severity: "error",
      });
    }
  };
  const handleRegenerateDrafts = () => {
    handleAIGeneration();
  };
  const toggleDraftSelection = (draftId, checked) => {
    setAiModal((prev) => ({
      ...prev,
      selectedDraftIds: checked
        ? [...new Set([...prev.selectedDraftIds, draftId])]
        : prev.selectedDraftIds.filter((id) => id !== draftId),
    }));
  };
  const updateDraftValidOptions = (draftId, nextValidOptions) => {
    setAiModal((prev) => ({
      ...prev,
      drafts: prev.drafts.map((draft) =>
        draft.draftId === draftId
          ? { ...draft, validOptions: [...new Set(nextValidOptions)] }
          : draft
      ),
    }));
  };
  const updateDraftTextValidOptions = (draftId, textValue) => {
    const values = String(textValue || "")
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
    updateDraftValidOptions(draftId, values);
  };
  const handleApplyAIDrafts = async () => {
    const objective = aiModal?.objective?.trim();
    if (!objective || objective.length < 10) {
      setSnackbar({
        open: true,
        msg: "Please add an objective with at least 10 characters.",
        severity: "error",
      });
      return;
    }
    const approvedDrafts = aiModal?.drafts?.filter((draft) =>
      aiModal?.selectedDraftIds?.includes(draft?.draftId)
    );
    if (!approvedDrafts?.length) {
      setSnackbar({
        open: true,
        msg: "Please select at least one draft to apply.",
        severity: "error",
      });
      return;
    }

    setAiModal((prev) => ({ ...prev, applying: true, progress: 0 }));
    try {
      const result = await applyAIQualifications(id, objective, approvedDrafts);
      await getSingleSurvey();
      await getTableQualification();
      setAiModal((prev) => ({ ...prev, progress: 100 }));
      closeAIModal();
      setSnackbar({
        open: true,
        msg: `Applied ${result?.addedQualifications || 0} qualification(s).`,
        severity: "success",
      });
    } catch (error) {
      setAiModal((prev) => ({ ...prev, applying: false }));
      setSnackbar({
        open: true,
        msg: error?.response?.data?.error || "Unable to apply AI qualifications.",
        severity: "error",
      });
    }
  };
  const toggleQualificationStatus = async (qualificationID) => {
    try {
      let data = await axios.put(
        `${BASE_URL}/survey/toggle-qualification-status/${id}/${qualificationID}`
      );
      await getSingleSurvey(id);
      setSnackbar({
        open: true,
        msg: "Qualification status updated !",
        severity: "success",
      });
      getTableQualification();
    } catch (error) {
      setSnackbar({
        open: true,
        msg: "something went wrong !",
        severity: "error",
      });
    }
  };
  const closeQualificationModal = () => handleClose("qualification");
  const qualificationFormProps = {
    allQuestions,
    edit,
    getTableQualification,
    data,
    id,
    getSingleSurvey,
    onClose: closeQualificationModal,
    setSnackbar,
  };
  const renderAddQualification = () => {
    switch (tab) {
      case 0:
        return <MultiPunch {...qualificationFormProps} />;
      case 1:
        return <SinglePunch {...qualificationFormProps} />;
      case 2:
        return <Numeric {...qualificationFormProps} />;
      case 3:
        return <Text {...qualificationFormProps} />;
      default:
        return <h1>No data</h1>;
    }
  };
  const handleCloseModal = (e) => setDeleteM((prev) => ({ open: false }));
  const deleteQualification = async (e) => {
    e.preventDefault();
    axios
      .put(
        `${BASE_URL}/survey/delete-qualification?sid=${id}&qid=${deleteM?.data?._id}`
      )
      .then((res) => {
        getTableQualification();
        getSingleSurvey();
        setDeleteM({ open: false });
        setSnackbar({
          msg: "Supplier Deleted Successfully !",
          open: true,
          severity: "success",
        });
      })
      .catch((er) => {
        getSingleSurvey();
        setDeleteM({ open: false });
        setSnackbar({
          msg: "Something went wrong !",
          open: false,
          severity: "error",
        });
      });
  };
  const filteredQualificationTable = qualificationTable
    ?.filter((f) =>
      !filters?.status
        ? f
        : filters?.status === "Active"
        ? f.status === true
        : f?.status === false
    )
    ?.filter((d) =>
      !filters?.search
        ? d
        : d?.question?.questionName
            ?.toLowerCase()
            ?.includes(filters?.search?.toLowerCase()) ||
          String(d?.question?.questionId)?.includes(filters?.search)
    );
  // console.log(qualificationTable);
  // console.log(filters);
  // console.log(edit);
  // console.log(previewData);
  return (
    <div className="w-full flex flex-col gap-6">
      {/* Header */}
      <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0]">
        <div>
          <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
            Qualifications
          </h1>
          <p className="text-[#666] text-[14px] font-[400]">
            Manage survey qualification questions and logic
          </p>
        </div>
      </div>

      {/* Filters and Actions */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-4 flex items-center justify-between gap-4">
        <select
          className="border border-gray-300 rounded-md py-2 px-4 text-[#333] text-[14px] h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white min-w-[160px]"
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, status: e.target.value }))
          }
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 12px center',
            backgroundSize: '12px'
          }}
        >
          <option value="">All Status</option>
          {["Active", "Inactive"]?.map((d, i) => (
            <option value={d} key={i}>
              {d}
            </option>
          ))}
        </select>
        <div className="flex items-center gap-3 flex-1 justify-end">
          <div className="w-full max-w-md flex items-center relative">
            <AiOutlineSearch
              className="absolute left-4 text-gray-400"
              size={18}
            />
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md pl-11 pr-4 py-3 text-[#1a1a1a] font-[400] text-[14px] h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 placeholder:text-gray-400 hover:border-gray-400"
              placeholder="Search by question ID or qualification name"
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, search: e.target.value }))
              }
            />
          </div>
          <button
            className="px-6 py-3 text-[#0226BE] rounded-md border border-[#0226BE] bg-white text-[14px] font-[500] hover:bg-blue-50 transition-colors whitespace-nowrap"
            onClick={openAIModal}
          >
            Create with AI
          </button>
          <button
            className="px-6 py-3 text-white rounded-md bg-[#0226BE] text-[14px] font-[500] hover:bg-[#021ea8] transition-colors whitespace-nowrap"
            onClick={(e) => handleOpen("qualification")}
          >
            Add Qualification
          </button>
        </div>
      </div>

      {/* Qualifications Table */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
        {!filteredQualificationTable?.length ? (
          <div className="p-8">
            <NoData
              msg={
                <div className="flex items-center gap-2 cursor-pointer">
                  <span>Try adding a</span>
                  <span
                    className="text-[#0226BE] font-[500] underline underline-offset-2 decoration-2 hover:no-underline"
                    onClick={(e) => handleOpen("qualification")}
                  >
                    New Qualification
                  </span>
                </div>
              }
            />
          </div>
        ) : (
          <div className="w-full overflow-x-auto containerScroll">
            <table
              className="whitespace-nowrap text-left w-full"
              id="table-to-xls-DATA"
            >
              <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                <tr>
                  <th className="text-[#666] text-[13px] font-[500] px-5 text-start">
                    Question ID
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Qualifications
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Conditions
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Status
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredQualificationTable?.map((data, ind) => (
                  <tr
                    className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                    key={ind}
                  >
                    <td className="px-5 py-4 text-[#333] font-[400] text-[13px]">
                      {data?.question?.questionId ?? data?.question?._id ?? "-"}
                    </td>
                    <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                      {data?.question?.questionName || "-"}
                    </td>
                    <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                      <div className="flex items-center gap-2 max-w-[400px] flex-wrap max-h-[120px] overflow-y-auto containerScroll">
                        {data?.validOptions?.filter((d) => d)?.length
                          ? data?.validOptions?.map(
                              (mdata, validOptionsKey) => (
                                <span
                                  className="py-1.5 px-3 border border-[#0226BE]/30 text-[#0226BE] bg-blue-50/50 rounded-md text-[11px] font-[500]"
                                  key={validOptionsKey}
                                >
                                  {data?.question?.questionType ===
                                  "Numeric - Open-end"
                                    ? `${mdata?.from}-${mdata?.to}`
                                    : mdata}
                                </span>
                              )
                            )
                          : <span className="text-gray-400 text-[12px]">No Conditions</span>}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-3">
                        <span
                          className={`px-3 py-1 rounded-full text-[11px] font-[500] ${
                            data?.status
                              ? "bg-green-50 text-green-700 border border-green-200"
                              : "bg-gray-50 text-gray-600 border border-gray-200"
                          }`}
                        >
                          {data?.status ? "Active" : "Inactive"}
                        </span>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={data?.status}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                if (
                                  qualificationTable?.filter((d) => d?.status)
                                    ?.length > 1
                                ) {
                                  toggleQualificationStatus(data?._id);
                                } else {
                                  setSnackbar({
                                    open: true,
                                    msg: "One qualification must be active !",
                                    severity: "error",
                                  });
                                }
                              } else {
                                toggleQualificationStatus(data?._id);
                              }
                            }}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#0226BE]"></div>
                        </label>
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-3">
                        <button
                          onClick={(e) => {
                            handleOpen("qualification");
                            setEdit((prev) => ({
                              ...prev,
                              isEdit: true,
                              data: data,
                            }));
                            switch (data?.question?.questionType) {
                              case "Multi Punch":
                                return setTab(0);
                              case "Single Punch":
                                return setTab(1);
                              case "Dummy":
                                return setTab(1);
                              case "Numeric - Open-end":
                                return setTab(2);
                              case "Text - Open-end":
                                return setTab(3);
                            }
                          }}
                          className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                        >
                          <MdOutlineModeEditOutline
                            className="text-[#0226BE]"
                            size={18}
                          />
                        </button>
                        <button
                          onClick={(e) => {
                            setDeleteM((prev) => ({
                              ...prev,
                              open: true,
                              data: data,
                            }));
                          }}
                          className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                        >
                          <MdDeleteOutline
                            className="text-red-500"
                            size={18}
                          />
                        </button>
                        <button
                          onClick={(e) => {
                            handleOpen("preview");
                            setPreviewData(data);
                          }}
                          className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                        >
                          <AiOutlineEye
                            className="text-[#666]"
                            size={18}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <DeleteModal
        open={deleteM?.open}
        handleClose={handleCloseModal}
        text={deleteM?.data?.question?.questionName}
        handleClick={deleteQualification}
      />
      {/* Add Qualification Modal*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modal.qualification}
        onClose={(e) => handleClose("qualification")}
        closeAfterTransition
        disableEnforceFocus
        disableAutoFocus
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modal.qualification}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col max-h-[90vh]">
              {/* Modal Header */}
              <div className="w-full py-4 px-6 border-b border-[#E0E0E0] flex items-center justify-between shrink-0">
                <h1 className="text-[#333] text-[18px] font-[500]">
                  {edit?.isEdit ? "Edit" : "Add"} Qualification Question
                </h1>
                <button
                  type="button"
                  onClick={() => handleClose("qualification")}
                  className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                >
                  <RxCross2 size={20} className="text-[#666]" />
                </button>
              </div>

              {/* Tab Navigation */}
              <div className="w-full flex items-center px-6 py-4 border-b border-[#E0E0E0] gap-6 overflow-x-auto shrink-0">
                {[
                  "Multi Choice",
                  "Single Choice",
                  "Numeric-Open End",
                  "Text Entry",
                ]?.map((tabLabel, ind) => (
                  <button
                    key={tabLabel}
                    type="button"
                    className={`text-[13px] font-[400] cursor-pointer transition-all pb-2 border-b-2 whitespace-nowrap ${
                      tab == ind
                        ? `text-[#0226BE] font-[600] border-[#0226BE]`
                        : `text-[#666] border-transparent hover:text-[#0226BE] hover:border-[#0226BE]/30`
                    } ${
                      edit?.isEdit && tab != ind
                        ? "text-gray-400 cursor-not-allowed hover:text-gray-400 hover:border-transparent"
                        : ""
                    }`}
                    onClick={() => {
                      if (!edit?.isEdit) {
                        setTab(ind);
                      }
                    }}
                  >
                    {tabLabel}
                  </button>
                ))}
              </div>
              <div
                key={`${tab}-${edit?.data?._id || "new"}`}
                className="w-full overflow-y-auto containerScroll pb-4"
              >
                {modal.qualification ? renderAddQualification() : null}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* AI qualification modal */}
      <Modal
        aria-labelledby="ai-qualification-title"
        aria-describedby="ai-qualification-description"
        open={aiModal?.open}
        onClose={(e, reason) => {
          if (aiModal?.loading || aiModal?.applying) return;
          closeAIModal();
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={aiModal?.open}>
          <Box
            sx={{
              ...style,
              width: "min(95vw, 840px)",
              maxHeight: "85vh",
              height: "auto",
              minHeight: "min(400px, 60vh)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="w-full flex flex-col flex-1 min-h-0 overflow-hidden" style={{ minHeight: 0 }}>
              <div className="w-full py-4 px-6 border-b border-[#E0E0E0] flex items-center justify-between flex-shrink-0">
                <div>
                  <h1
                    id="ai-qualification-title"
                    className="text-[#333] text-[18px] font-[500]"
                  >
                    Create Qualifications with AI
                  </h1>
                  <p
                    id="ai-qualification-description"
                    className="text-[#666] text-[13px] mt-1"
                  >
                    AI finds similar existing questions first, then creates missing ones in My Questions.
                  </p>
                </div>
                <button
                  onClick={closeAIModal}
                  disabled={aiModal?.loading || aiModal?.applying}
                  className="p-1 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <RxCross2 size={20} className="text-[#666]" />
                </button>
              </div>
              {(aiModal?.loading || aiModal?.applying) && (
                <div className="px-6 py-4 flex-shrink-0 border-b border-[#E0E0E0]">
                  <LinearProgress
                    variant="determinate"
                    value={aiModal?.progress || 0}
                    sx={{ height: 8, borderRadius: 4 }}
                    color="primary"
                  />
                  <p className="text-[12px] text-[#666] mt-2">
                    Estimated time: ~15–30 seconds. Please wait…
                  </p>
                </div>
              )}
              {aiModal?.stage !== "review" ? (
                <div className="px-6 py-5 flex flex-col gap-3 flex-shrink-0">
                  <label className="text-[#333] text-[14px] font-[500]">
                    Objective
                  </label>
                  <textarea
                    rows={5}
                    value={aiModal?.objective}
                    onChange={(e) =>
                      setAiModal((prev) => ({
                        ...prev,
                        objective: e.target.value,
                      }))
                    }
                    placeholder="Describe target audience, exclusions, and qualification requirements."
                    className="w-full border border-gray-300 rounded-md px-4 py-3 text-[#1a1a1a] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] placeholder:text-gray-400 resize-y min-h-[120px]"
                  />
                  <p className="text-[12px] text-[#666]">
                    Tip: Include audience profile, exclusion criteria, and must-have respondent traits.
                  </p>
                </div>
              ) : null}
              {aiModal?.stage === "review" ? (
                <div className="px-6 pb-2 flex flex-col gap-3 flex-1 min-h-0 overflow-hidden flex flex-col">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <h3 className="text-[#333] text-[14px] font-[600]">
                      Review Generated Drafts
                    </h3>
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="text-[12px] text-[#666]">
                        {aiModal?.selectedDraftIds?.length || 0} selected
                      </p>
                      <button
                        type="button"
                        disabled={aiModal?.loading || aiModal?.applying}
                        onClick={handleAIGeneration}
                        className="px-3 py-1.5 text-[13px] font-[500] text-[#0226BE] bg-blue-50 border border-[#0226BE]/30 rounded-md hover:bg-blue-100 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        {aiModal?.loading ? "Regenerating..." : "Regenerate Drafts"}
                      </button>
                    </div>
                  </div>
                  <div className="flex flex-col gap-3 overflow-y-auto containerScroll flex-1 min-h-0 pb-2 max-h-[calc(85vh-280px)]">
                  {!aiModal?.drafts?.length ? (
                    <p className="text-[13px] text-[#666]">
                      No drafts were generated. Please refine the objective and try again.
                    </p>
                  ) : (
                    aiModal?.drafts?.map((draft, idx) => (
                      <div
                        key={draft?.draftId || idx}
                        className={`border rounded-md p-3 ${
                          draft?.alreadyApplied
                            ? "border-gray-200 bg-gray-50"
                            : "border-[#E0E0E0] bg-white"
                        }`}
                      >
                        <div className="flex items-start gap-3">
                          <input
                            type="checkbox"
                            checked={aiModal?.selectedDraftIds?.includes(draft?.draftId)}
                            disabled={draft?.alreadyApplied}
                            onChange={(e) =>
                              toggleDraftSelection(draft?.draftId, e.target.checked)
                            }
                            className="mt-1 w-4 h-4"
                          />
                          <div className="w-full flex flex-col gap-2">
                            <div className="flex items-center justify-between gap-3">
                              <h4 className="text-[14px] font-[500] text-[#333]">
                                {draft?.questionText}
                              </h4>
                              <span className="text-[11px] px-2 py-1 bg-blue-50 text-[#0226BE] rounded-md border border-blue-200 whitespace-nowrap">
                                {draft?.questionType}
                              </span>
                            </div>
                            {draft?.alreadyApplied ? (
                              <p className="text-[12px] text-gray-500">
                                Similar qualification is already applied on this survey.
                              </p>
                            ) : null}
                            {draft?.questionType === "Single Punch" ||
                            draft?.questionType === "Multi Punch" ? (
                              <div className="flex flex-col gap-1">
                                <p className="text-[12px] text-[#666] font-[500]">
                                  Valid Answers
                                </p>
                                <div className="grid grid-cols-2 gap-2">
                                  {(draft?.options || []).map((option, optionIdx) => {
                                    const isChecked = (draft?.validOptions || []).includes(
                                      option
                                    );
                                    return (
                                      <label
                                        key={`${option}-${optionIdx}`}
                                        className="flex items-center gap-2 text-[12px] text-[#333]"
                                      >
                                        <input
                                          type="checkbox"
                                          checked={isChecked}
                                          onChange={(e) => {
                                            const current = draft?.validOptions || [];
                                            let next = e.target.checked
                                              ? [...current, option]
                                              : current.filter((v) => v !== option);
                                            if (
                                              draft?.questionType === "Single Punch" &&
                                              e.target.checked
                                            ) {
                                              next = [option];
                                            }
                                            updateDraftValidOptions(draft?.draftId, next);
                                          }}
                                          className="w-4 h-4"
                                        />
                                        <span>{option}</span>
                                      </label>
                                    );
                                  })}
                                </div>
                              </div>
                            ) : (
                              <div className="flex flex-col gap-1">
                                <p className="text-[12px] text-[#666] font-[500]">
                                  Valid Keywords (comma separated)
                                </p>
                                <input
                                  type="text"
                                  value={(draft?.validOptions || []).join(", ")}
                                  onChange={(e) =>
                                    updateDraftTextValidOptions(
                                      draft?.draftId,
                                      e.target.value
                                    )
                                  }
                                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE]"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  </div>
                </div>
              ) : null}
              <div className="w-full px-6 py-4 border-t border-[#E0E0E0] flex items-center justify-end gap-3 flex-shrink-0">
                <button
                  type="button"
                  onClick={closeAIModal}
                  disabled={aiModal?.loading || aiModal?.applying}
                  className="px-5 py-2.5 text-[#666] text-[14px] font-[500] bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  disabled={aiModal?.loading || aiModal?.applying}
                  onClick={
                    aiModal?.stage === "review"
                      ? handleApplyAIDrafts
                      : handleAIGeneration
                  }
                  className="px-6 py-2.5 text-white text-[14px] font-[500] bg-[#0226BE] rounded-md hover:bg-[#021ea8] transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {aiModal?.loading || aiModal?.applying ? (
                    <>
                      <CircularProgress size={16} className="text-white" />
                      <span>
                        {aiModal?.stage === "review" ? "Applying..." : "Generating..."}
                      </span>
                    </>
                  ) : (
                    <span>
                      {aiModal?.stage === "review"
                        ? "Apply Selected Questions"
                        : "Generate Drafts"}
                    </span>
                  )}
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* preview modal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modal?.preview}
        onClose={(e) => handleClose("preview")}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modal?.preview}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col">
              <div className="w-full py-4 px-6 border-b border-[#E0E0E0] flex items-center justify-between">
                <h1 className="text-[#333] text-[18px] font-[500]">
                  Question Preview
                </h1>
                <button
                  onClick={() => handleClose("preview")}
                  className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                >
                  <RxCross2 size={20} className="text-[#666]" />
                </button>
              </div>

              <div className="w-full p-6 flex flex-col gap-6">
                <h2 className="text-[#333] text-[16px] font-[500] capitalize">
                  {previewData?.question?.questionText}
                </h2>
                {/* {(previewData?.question?.questionType == "Multi Punch" ||
                  previewData?.question?.questionType == "Single Punch") &&
                Object.keys(previewData?.condition || {})?.length ? (
                  <h1 className={`pl-2 bg-gray-200 py-2 text-[#666]`}>
                    <Required />{" "}
                    {previewData?.condition?.min === previewData?.condition?.max
                      ? `You need to select exactly ${previewData?.condition?.min} options.`
                      : previewData?.condition?.min &&
                        previewData?.condition?.max
                      ? `You can only select minimum ${previewData?.condition?.min} and maximum ${previewData?.condition?.max}`
                      : previewData?.condition?.min &&
                        !previewData?.condition?.max
                      ? `You need to atleast select ${previewData?.condition?.min}`
                      : !previewData?.condition?.min &&
                        previewData?.condition?.max
                      ? `You need to atleast select only maximum of ${previewData?.condition?.max}`
                      : ""}
                  </h1>
                ) : (
                  ""
                )} */}
                {previewData?.question?.questionType == "Multi Punch" ||
                previewData?.question?.questionType == "Single Punch" ||
                previewData?.question?.questionType == "Dummy" ? (
                  <div className="w-full max-h-[300px] overflow-y-auto containerScroll flex flex-col gap-2 border border-gray-300 rounded-md p-2 bg-white">
                    {previewData?.displayOptions?.map((data, ind) => {
                      const isValid = previewData?.validOptions?.includes(data);
                      return (
                        <label
                          htmlFor={`preview-${data}-${ind}`}
                          className={`w-full flex items-center gap-3 px-4 py-3 rounded-md border-2 transition-all cursor-pointer group ${
                            isValid
                              ? "border-gray-200 hover:border-[#0226BE]/40 hover:bg-blue-50/50"
                              : "border-gray-100 opacity-50 cursor-not-allowed"
                          }`}
                          key={ind}
                        >
                          {previewData?.question?.questionType ==
                          "Multi Punch" ? (
                            <input
                              type="checkbox"
                              name={data}
                              id={`preview-${data}-${ind}`}
                              disabled={!isValid}
                              className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 rounded cursor-pointer disabled:opacity-50 transition-all"
                            />
                          ) : (
                            <input
                              type="radio"
                              name="singlePunchOption"
                              id={`preview-${data}-${ind}`}
                              disabled={!isValid}
                              className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 cursor-pointer disabled:opacity-50 transition-all"
                            />
                          )}

                          <span className="text-[14px] font-[400] text-[#333] flex-1 capitalize select-none">
                            {data}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                ) : (
                  <input
                    type={`${
                      previewData?.question?.questionType ==
                      "Numeric - Open-end"
                        ? "number"
                        : "text"
                    }`}
                    step="any"
                    placeholder="Enter answer"
                    disabled
                    className="w-full max-w-md border border-gray-300 rounded-md pl-4 pr-4 py-3 text-[#666] font-[400] text-[14px] h-[48px] bg-gray-50"
                  />
                )}
                <div className="flex flex-col gap-3">
                  <h3 className="text-[#333] text-[14px] font-[500]">
                    Valid Answers
                  </h3>
                  <div className="flex items-center gap-2 w-full flex-wrap max-h-[150px] overflow-y-auto containerScroll">
                    {previewData?.question?.questionType !==
                    "Numeric - Open-end"
                      ? previewData?.validOptions?.map((d, key) => (
                          <span
                            className="border border-[#0226BE]/30 text-[#0226BE] bg-blue-50/50 py-1.5 px-3 text-[12px] font-[500] rounded-md"
                            key={key}
                          >
                            {d}
                          </span>
                        ))
                      : previewData?.validOptions?.map((d, key) => (
                          <span
                            className="border border-[#0226BE]/30 text-[#0226BE] bg-blue-50/50 py-1.5 px-3 text-[12px] font-[500] rounded-md"
                            key={key}
                          >
                            {d?.from}-{d?.to}
                          </span>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* ADD LOGIC MODAL FIRST */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={addLogicModal.firstModal}
        onClose={(e) => {
          setAddLogicModal({
            firstModal: false,
            secondModal: false,
          });
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={addLogicModal.firstModal}>
          <Box sx={firstModalStyle}>
            <div className="w-full flex items-center flex-col py-1 pb-3">
              <div className="w-full  py-6 relative border-b ">
                <h1 className="text-[#333333] text-center text-[20px] font-[500]  pl-5">
                  Add Logic
                </h1>
                <p
                  className="  py-1 px-1 rounded-[50%] w-fit absolute top-3 cursor-pointer right-4"
                  onClick={() => {
                    setAddLogicModal({
                      firstModal: false,
                      secondModal: false,
                    });
                  }}
                >
                  <RxCross2 size={22} />
                </p>
              </div>
              <div className=" flex flex-col m-[16px]  rounded-[8px] pl-5 py-3  border w-[95%]">
                <div className="flex flex-col w-[94%] gap-[20px]">
                  <div className="flex text-[14px] flex-col gap-2">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      className=" border rounded-[4px] px-[16px] py-[6px] text-[#12112766]"
                      placeholder="Mayank Patel"
                    />
                  </div>

                  <div className="flex text-[14px] flex-col gap-2">
                    <label htmlFor="">Add another conditions</label>
                    <input
                      type="text"
                      className=" border rounded-[4px] px-[16px] py-[6px] text-[#12112766]"
                      placeholder="Mayank Patel"
                    />
                  </div>

                  <div className="flex text-[14px] justify-between">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="">From</label>
                      <input
                        type="text"
                        className="w-[181px] border rounded-[4px] px-[16px] py-[6px] text-[#12112766]"
                        placeholder="Mayank Patel"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label htmlFor="">To</label>
                      <input
                        type="text"
                        className="w-[181px] border rounded-[4px] px-[16px] py-[6px] text-[#12112766]"
                        placeholder="Mayank Patel"
                      />
                    </div>
                  </div>

                  <label className="h-[48px] text-[14px] flex items-center gap-4 border-2 border-gray-200 rounded-md px-4 bg-white hover:border-[#0226BE]/40 hover:bg-blue-50/30 transition-all cursor-pointer group">
                    <input
                      type="radio"
                      name="logicCondition"
                      id="is-condition"
                      className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 cursor-pointer transition-all"
                    />
                    <span className="text-[#333] font-[400] select-none">IS</span>
                  </label>

                  <label className="h-[48px] text-[14px] flex items-center gap-4 border-2 border-gray-200 rounded-md px-4 bg-white hover:border-[#0226BE]/40 hover:bg-blue-50/30 transition-all cursor-pointer group">
                    <input
                      type="radio"
                      name="logicCondition"
                      id="is-not-condition"
                      className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 cursor-pointer transition-all"
                    />
                    <span className="text-[#333] font-[400] select-none">IS NOT</span>
                  </label>

                  <div className="flex items-center justify-between w-[60%]">
                    <span className="text-[14px] text-[#333]">
                      Add Another Conditions
                    </span>
                    <span>
                      <IoMdAddCircleOutline />
                    </span>
                  </div>

                  <button
                    className="bg-[#0226BE] text-[white] justify-center items-center flex h-[40px] rounded-[4px]"
                    onClick={() => {
                      setAddLogicModal({
                        firstModal: false,
                        secondModal: true,
                      });
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* ADD LOGIC MODAL SECOND */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={addLogicModal.secondModal}
        onClose={(e) => {
          setAddLogicModal({
            firstModal: false,
            secondModal: false,
          });
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={addLogicModal.secondModal}>
          <Box sx={firstModalStyle}>
            <div className="w-full flex items-center flex-col py-1 pb-3">
              <div className="w-full  py-6 relative border-b ">
                <h1 className="text-[#333333] text-center text-[20px] font-[500]  pl-5">
                  Add Logic
                </h1>
                <p
                  className="  py-1 px-1 rounded-[50%] w-fit absolute top-3 cursor-pointer right-4"
                  onClick={() => {
                    setAddLogicModal({
                      firstModal: false,
                      secondModal: false,
                    });
                  }}
                >
                  <RxCross2 size={22} />
                </p>
              </div>
              <div className=" flex flex-col m-[16px]  rounded-[8px] pl-5 py-3  border w-[95%]">
                <div className="flex flex-col w-[95%] gap-[20px]">
                  <div className="flex text-[14px] flex-col gap-3">
                    <label htmlFor="name" className="text-[#333] font-[500]">Result</label>
                    <label className="h-[48px] text-[14px] flex items-center gap-4 border-2 border-gray-200 rounded-md px-4 bg-white hover:border-[#0226BE]/40 hover:bg-blue-50/30 transition-all cursor-pointer group">
                      <input
                        type="radio"
                        name="result"
                        id="jump-to"
                        className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 cursor-pointer transition-all"
                      />
                      <span className="text-[#333] font-[400] select-none">Jump to</span>
                    </label>
                  </div>

                  <select
                    name=""
                    id=""
                    className="h-[48px] border border-gray-300 rounded-md pl-4 pr-10 py-3 text-[#1a1a1a] font-[400] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 appearance-none cursor-pointer hover:border-gray-400 bg-white"
                    style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 12px center',
                      backgroundSize: '12px'
                    }}
                  >
                    <option value="">Age</option>
                  </select>

                  <div className="flex text-[14px] flex-col gap-3">
                    <label className="h-[48px] text-[14px] flex items-center gap-4 border-2 border-gray-200 rounded-md px-4 bg-white hover:border-[#0226BE]/40 hover:bg-blue-50/30 transition-all cursor-pointer group">
                      <input
                        type="radio"
                        name="result"
                        id="terminate"
                        className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 cursor-pointer transition-all"
                      />
                      <span className="text-[#333] font-[400] select-none">Terminate</span>
                    </label>
                  </div>

                  <div className="flex text-[14px] flex-col gap-3">
                    <label className="h-[48px] text-[14px] flex items-center gap-4 border-2 border-gray-200 rounded-md px-4 bg-white hover:border-[#0226BE]/40 hover:bg-blue-50/30 transition-all cursor-pointer group">
                      <input
                        type="radio"
                        name="result"
                        id="jump-to-client"
                        className="w-5 h-5 border-2 border-gray-300 text-[#0226BE] focus:ring-2 focus:ring-[#0226BE] focus:ring-offset-1 cursor-pointer transition-all"
                      />
                      <span className="text-[#333] font-[400] select-none">Jump to client survey</span>
                    </label>
                  </div>

                  <button className="bg-[#0226BE] text-[white] justify-center items-center flex h-[40px] rounded-[4px]">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default Qualification;
